import { useEffect, useRef, RefObject } from 'react';

export function useInfiniteScroll(
  onLoadMore: () => void,
  enabled: boolean,
  deps: unknown[] = []
): RefObject<HTMLDivElement | null> {
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el || !enabled) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) onLoadMore();
      },
      { rootMargin: '240px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, onLoadMore, ...deps]);

  return sentinelRef;
}
